import BaseService from "./BaseService";
import AppConfiguration from "dataProvider/config";

export default class TrackerService extends BaseService {

    constructor() {
        super(AppConfiguration.apiBaseMap, "tracker");
    }

    async getTruckTrackers(params) {
        const path = "truck-management/truck-trackers"
        const configs = this.getConfigs({
            params
        })
        return await this.doGet(path, configs)
    }
    async getMonitoringInfo(params) {
        let path = `/truck-state/geojson-v3`;
        const configs = this.getConfigs({
            params
        })
        return await this.doGet(path, configs)
    }
    async getTrackerUsageLogMonitoringScreen() {
        let path = `/usage-log/monitoring-screen`;
        return await this.doGet(path);
    }
    async clearExtractLock() {
        let path = `/setting/clear-extract-lock?name=SYNC_TRUCK`;
        return await this.doGet(path);
    }
}